<div class="grid-toolbar" id="gridToolbar" *ngIf="showToolbar">
  <div class="grid-toolbar-container">
    <div class="grid-toolbar-body">
      <ul class="toolbar-list" #toolbarList *ngIf="!customToolbar">
        <li class="toolbar-list-item" (click)="refresh()">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-refresh"></i>
            </span>
            <span class="list-item-title">{{ "refresh" | translate }}</span>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton && !initStatesWithChild && doAdd"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-plus"></i>
            </span>
            <span class="list-item-title" (click)="openNew()">{{
              "add" | translate
            }}</span>
            <div
              dropdown
              container="body"
              class="list-dropdown"
              *ngIf="initStatesWithoutChild"
            >
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                *dropdownMenu
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
              >
                <li
                  class="wj-listbox-item"
                  [class.disabled]="disabledButton"
                  role="menuitem"
                  *ngFor="let initState of initStatesWithoutChild"
                  (click)="openNew(initState)"
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">{{
                    initState.label | translate
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
                [class.disabled]="disabledButton"
                class="toolbar-list-item"
                *ngIf="showButton && !initStatesWithChild && doAdd"
        >
          <div
            class="list-button"
            klClickOutside
            (clickOutside)="menuWithChild.collapsed = false"
          >
            <span class="list-item-title with-child">
              <span>{{ "add" | translate }} </span>
            </span>
            <i
              class="fal fa-angle-down dropdown-element"
              aria-hidden="true"
            ></i>
            <div
              class="list-dropdown nested-dropdown-menu"
              #menuWithChild
              [collapse]="!menuWithChild.collapsed"
            >
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                aria-labelledby="dropdownMenu"
              >
                <li
                  class="wj-listbox-item"
                  *ngFor="let initState of initStatesWithChild"
                >
                  <span class="list-head"></span>
                  <a class="dropdown-item">{{ initState.label | translate }}</a>
                  <ul
                    class="submenu grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                  >
                    <li
                      [class.disabled]="disabledButton"
                      *ngFor="let childInitState of initState.child"
                      (click)="openNew(childInitState)"
                    >
                      <span class="list-head"></span>
                      <a class="dropdown-item">{{
                        childInitState.label | translate
                      }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="sortable"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-list"></i>
            </span>
            <span class="list-item-title" (click)="openSortable()">{{
              "Tasarımı düzenle"
            }}</span>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton"
        >
          <div
            class="list-button"
            (click)="!disabledButton ? explorerDelete() : null"
          >
            <span class="list-icon">
              <i class="fal fa-trash"></i>
            </span>
            <span class="list-item-title">{{ "delete" | translate }}</span>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-pencil"></i>
            </span>
            <span
              class="list-item-title"
              (click)="!disabledButton ? explorerEdit() : null"
              >{{ "edit" | translate }}</span
            >
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li
                  class="wj-listbox-item"
                  [class.disabled]="disabledButton"
                  role="menuitem"
                  (click)="!disabledButton ? explorerView() : null"
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">{{
                    "view" | translate
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="toolbar-list-item" *ngIf="showButton && filterable">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-filter" aria-hidden="true"></i>
            </span>
            <span class="list-item-title" (click)="toggleFilterContainer()">{{
              "filter" | translate
            }}</span>
            <div
              dropdown
              container="body"
              class="list-dropdown"
              *ngIf="customFilter"
            >
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li class="wj-listbox-item" (click)="customFilterOpen()">
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">
                    <i class="fal fa-filter"></i>&nbsp;{{
                      "detail_filter" | translate
                    }}</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-bars" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{ "other" | translate }}</span>
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li
                  class="wj-listbox-item"
                  [class.disabled]="disabledButton"
                  role="menuitem"
                >
                  <span class="list-head"></span>
                  <span
                    class="grid-dropdown-span"
                    (click)="!disabledButton ? explorerInfo() : false"
                    >{{ "entry_info" | translate }}</span
                  >
                </li>
                <li
                  class="wj-listbox-item"
                  [class.disabled]="disabledButton"
                  role="menuitem"
                  *ngFor="let action of actions"
                  (click)="
                    hasProperty(currentItem, 'id')
                      ? !action.separator
                        ? action.method({item: currentItem})
                        : false
                      : false
                  "
                >
                  <span class="list-head"></span>
                  <a
                    class="hr"
                    style="margin: 0 !important"
                    *ngIf="action.separator"
                  ></a>
                  <span class="grid-dropdown-span" *ngIf="!action.separator">{{
                    action.slug | translate
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton && processesActions"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-bars" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{ "processes" | translate }}</span>
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li
                  class="wj-listbox-item"
                  [class.disabled]="disabledButton"
                  role="menuitem"
                  *ngFor="let action of processesActions"
                  (click)="
                    hasProperty(currentItem, 'id')
                      ? action.method({item: currentItem})
                      : null
                  "
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">{{
                    action.slug | translate
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="toolbar-list-item" *ngIf="showButton && authGroupShow">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-bars" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{
              "authorisation_groups" | translate
            }}</span>
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li
                  class="wj-listbox-item"
                  role="menuitem"
                  *ngFor="let groupList of authGroupList"
                  (click)="groupList.method()"
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">{{
                    groupList.label | translate
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          [class.disabled]="disabledButton"
          class="toolbar-list-item"
          *ngIf="showButton"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-upload" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{ "export" | translate }}</span>
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="grid-list-menu wj-dropdown-panel wj-listbox wj-content"
                role="menu"
                *dropdownMenu
              >
                <li
                  class="wj-listbox-item"
                  role="menuitem"
                  (click)="exportAs('PDF')"
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">
                    <i class="fal fa-file-pdf-o" aria-hidden="true"></i>
                    {{ "pdf" | translate }}</span
                  >
                </li>
                <li
                  class="wj-listbox-item"
                  role="menuitem"
                  (click)="exportAs('XLSX')"
                >
                  <span class="list-head"></span>
                  <span class="grid-dropdown-span">
                    <i class="fal fa-file-excel-o" aria-hidden="true"></i>
                    {{ "excel" | translate }}</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <ul class="toolbar-list" #customToolbarAnchor *ngIf="customToolbar">
        <li
          class="toolbar-list-item"
          *ngFor="let toolbar of customToolbar"
          (click)="(toolbar.method)"
        >
          <div class="list-button">
            <span class="list-icon">
              <i class="fal" [ngClass]="toolbar.icon"></i>
            </span>
            <span class="list-item-title">{{ toolbar.slug | translate }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="col-md-12 col-sm-12 form-header" [hidden]="!alertShow">
  <div class="left-group">
    <!--    <span class="title">{{gridHeaderName | translate}}</span>-->
    <div class="form-header-alert">
      <kl-alert
        [show]="alertShow"
        [message]="alertMessage"
        [type]="alertType"
        (onClose)="closeAlert()"
      ></kl-alert>
    </div>
  </div>
</div>
<div class="filter-container" *ngIf="showFilterContainer">
  <form #filterForm="ngForm" class="col-md-12 col-sm-12">
    <div class="form-row">
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
          <label class="sr-only" for="filter_text">{{
            "search_value" | translate
          }}</label>
          <input
            type="text"
            name="filter_text"
            (keydown.Enter)="submit()"
            placeholder="{{ 'search_value' | translate }}"
            id="filter_text"
            [(ngModel)]="textToFilter"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
          <select
            name="filter_type"
            class="form-control form-control-sm"
            [(ngModel)]="filterType"
          >
            <option
              *ngFor="let filterableItem of filterSelectItems"
              [ngValue]="filterableItem"
            >
              {{ filterableItem.description | translate }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <select
            name="filter_property"
            class="form-control form-control-sm"
            [(ngModel)]="filterExpression"
            id="filter_property"
          >
            <option value="LIKE" selected>{{ "LIKE" | translate }}</option>
            <option value="NOT_LIKE">{{ "NOT_LIKE" | translate }}</option>
            <option value="EQ">{{ "EQ" | translate }}</option>
            <option value="NOT_EQ">{{ "NOT_EQ" | translate }}</option>
            <option value="START_WITH">{{ "START_WITH" | translate }}</option>
            <option value="END_WITH">{{ "END_WITH" | translate }}</option>
            <option value="GT">{{ "GT" | translate }}</option>
            <option value="GE">{{ "GE" | translate }}</option>
            <option value="LT">{{ "LT" | translate }}</option>
            <option value="LE">{{ "LE" | translate }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <label class="sr-only" for="filter_count">Sayı</label>
          <input
            type="number"
            name="filter_count"
            id="filter_count"
            class="form-control form-control-sm"
            (keydown.Enter)="submit()"
            [(ngModel)]="pageSize"
            [value]="pageSize"
            [max]="maxCount"
            [min]="minCount"
          />
        </div>
      </div>
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <div class="btn-group" role="group" dropdown>
            <button
              type="button"
              (click)="submit()"
              class="btn btn-info btn-sm"
              [disabled]="isFilterButtonDisabled"
              #listData
            >
              <i class="fal fa-list" aria-hidden="true"></i>
              Listele
            </button>
            <button
              id="button-split"
              type="button"
              dropdownToggle
              class="btn btn-info"
              aria-controls="dropdown-split"
            >
              <i class="fal fa-angle-down" aria-hidden="true"></i>
            </button>
            <ul
              id="dropdown-split"
              *dropdownMenu
              class="dropdown-menu"
              role="menu"
              aria-labelledby="button-split"
            >
              <li role="menuitem" (click)="saveFastFilterLayout()">
                <span class="list-head"></span>
                <a class="dropdown-item">{{ "save" | translate }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="grid-content mb-1">
  <div class="ejs-grid" [hidden]="!collectionView?.sourceCollection?.length">
    <!--    <ejs-grid #flexGrid-->
    <!--              [attr.id]="'overviewgrid' + gridHeaderName"-->
    <!--              [dataSource]="collectionData"-->
    <!--              rowHeight="31"-->
    <!--              height="100%"-->
    <!--              [contextMenuItems]="contextMenuItems"-->
    <!--              [editSettings]='editing'-->
    <!--              [allowSelection]="true"-->
    <!--              [allowPaging]="false"-->
    <!--              [allowResizing]="true"-->
    <!--              [allowSorting]="true"-->
    <!--              [enableHover]="false"-->
    <!--              [allowFiltering]="false"-->
    <!--              [enableVirtualization]="deferResizing"-->
    <!--              [enableColumnVirtualization]="deferResizing"-->
    <!--              (rowSelected)="rowSelected($event)"-->
    <!--              (dblclick)="showButton ? explorerDblClickEdit($event) : false;"-->
    <!--              (contextMenuClick)="contextMenuClick($event)">-->
    <!--      <e-columns>-->
    <!--        <e-column *ngFor="let column of columns"-->
    <!--                  [type]="column.format"-->
    <!--                  [headerText]="column?.header | translate"-->
    <!--                  [field]="column.binding"-->
    <!--                  [visible]="column.visible"-->
    <!--                  [allowFiltering]="false"-->
    <!--                  [allowSorting]="false"-->
    <!--                  [width]="column.width ? column.width : (deferResizing ? 170 : '*')">-->
    <!--          <ng-template #template let-data>-->
    <!--            <div class="status-bar" *ngIf="column.format === 'status-bar'"-->
    <!--                 [ngClass]="data[column.binding] === 'YES' ? 'green' : 'red'"></div>-->
    <!--            <label *ngIf="column?.format === 'date'">-->
    <!--              {{data[column.binding] | klDate }}-->
    <!--            </label>-->
    <!--            <label *ngIf="column?.format === 'date-time'">-->
    <!--              {{data[column.binding] | klDate: true }}-->
    <!--            </label>-->
    <!--            <label *ngIf="column?.format === 'time'">-->
    <!--              {{data[column.binding] | klDate: false:true }}-->
    <!--            </label>-->
    <!--            <label *ngIf="column.translate">-->
    <!--              {{data[column.binding] | translate}}-->
    <!--            </label>-->
    <!--            <label *ngIf="!column.translate && !column.format">-->
    <!--              {{data[column.binding]}}-->
    <!--            </label>-->
    <!--          </ng-template>-->
    <!--        </e-column>-->
    <!--      </e-columns>-->
    <!--    </ejs-grid>-->

    <wj-flex-grid
      [wjContextMenu]="listGridMenu"
      #flexGrid
      [itemsSource]="collectionView"
      [selectionMode]="'Row'"
      [isReadOnly]="true"
      [deferResizing]="deferResizing"
      (dblclick)="showButton ? explorerDblClickEdit() : false"
    >
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'TopLeft'"
        style="max-width: 30px"
        *ngIf="gridName"
      >
        <div class="btn-group" dropdown container="body">
          <button
            class="btn p-0"
            style="color: #9e9e9e; background-color: transparent; outline: none"
            type="button"
            aria-haspopup="true"
            aria-expanded="true"
            container="body"
          >
            <i class="fal fa-cog" (click)="openSidebar()"></i>
          </button>
        </div>
      </ng-template>
      <wj-flex-grid-filter
        #flexGridFilterEl
        [flexGrid]="flexGrid"
        (editingFilter)="editingFilter(flexGridFilterEl, $event)"
        (filterChanged)="onFilterChanged()"
      ></wj-flex-grid-filter>
      <wj-flex-grid-column
        *ngFor="let column of columns"
        [header]="column?.header | translate"
        [binding]="column?.binding"
        [visible]="column?.visible"
        [width]="column?.width ? column?.width : '*'"
        [format]="column?.format"
      >
        <ng-template
          wjFlexGridCellTemplate
          [cellType]="'Cell'"
          let-cell="cell"
          *ngIf="column?.translate"
        >
          {{ cell.item[column.binding] | translate }}
        </ng-template>
        <ng-template
          wjFlexGridCellTemplate
          [cellType]="'Cell'"
          let-cell="cell"
          *ngIf="column?.multi_select"
        >
          <p-checkbox
            name="grid_checkbox"
            (onChange)="changeCheckBox($event, cell.item)"
            binary="true"
            styleClass="kl-checkbox"
          ></p-checkbox>
        </ng-template>
        <ng-template
          wjFlexGridCellTemplate
          [cellType]="'Cell'"
          let-cell="cell"
          *ngIf="column?.format === 'date'"
        >
          {{ cell.item[column.binding] | klDate }}
        </ng-template>
        <ng-template
          wjFlexGridCellTemplate
          [cellType]="'Cell'"
          let-cell="cell"
          *ngIf="column?.format === 'date-time'"
        >
          {{ cell.item[column.binding] | klDate : true }}
        </ng-template>
        <ng-template
          wjFlexGridCellTemplate
          [cellType]="'Cell'"
          let-cell="cell"
          *ngIf="column?.format === 'time'"
        >
          {{
            stringTimeConvert(cell.item[column.binding]) | klDate : false : true
          }}
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
    <wj-menu
      #listGridMenu
      id="list-grid-context-menu"
      (itemClicked)="menuItemClicked(listGridMenu)"
      [dropDownCssClass]="'grid-list-menu'"
      [displayMemberPath]="'header'"
      [hidden]="true"
    >
      <wj-menu-item [value]="'edit'">
        <span class="dropdown-item-icon"></span>
        <span class="grid-dropdown-span">{{ "edit" | translate }}</span>
      </wj-menu-item>
      <wj-menu-item [value]="'view'">
        <span class="dropdown-item-icon"></span>
        <span class="grid-dropdown-span">{{ "view" | translate }}</span>
      </wj-menu-item>
      <wj-menu-item [value]="'delete'">
        <span class="dropdown-item-icon"></span>
        <span class="grid-dropdown-span">{{ "delete" | translate }}</span>
      </wj-menu-item>
      <wj-menu-item [value]="'do_info'">
        <span class="dropdown-item-icon"></span>
        <span class="grid-dropdown-span">{{ "entry_info" | translate }}</span>
      </wj-menu-item>
      <wj-menu-separator style="padding: 0 !important"></wj-menu-separator>
      <wj-menu-item *ngFor="let action of actions" [value]="action.slug">
        <div
          class="hr"
          style="margin: 0 !important"
          *ngIf="action.separator"
        ></div>
        <div *ngIf="!action.separator">
          <span class="dropdown-item-icon"></span>
          <span class="grid-dropdown-span">{{ action.slug | translate }}</span>
        </div>
      </wj-menu-item>
      <wj-menu-item
        *ngFor="let action of processesActions"
        [value]="action.slug"
      >
        <div
          class="hr"
          style="margin: 0 !important"
          *ngIf="action.separator"
        ></div>
        <div *ngIf="!action.separator">
          <span class="dropdown-item-icon"></span>
          <span class="grid-dropdown-span">{{ action.slug | translate }}</span>
        </div>
      </wj-menu-item>
    </wj-menu>
  </div>
</div>
<p-sidebar
  [(visible)]="isSidebarShow"
  position="right"
  styleClass="kl-sidebar position-fixed"
  (onHide)="isSidebarShow = false"
>
  <div class="sidebar-header">
    <label>{{ "template_list" | translate }}</label>
  </div>
  <tabset>
    <tab [heading]="'grid_design' | translate" id="tab2">
      <a
        role="button"
        class="dropdown-item f-s-14 mt-1 mb-1"
        (click)="setDefaultTemplate()"
      >
        <i class="fal fa-columns" style="color: #9e9e9e" aria-hidden="true"></i>
        {{ "default_design" | translate }}
      </a>
      <a
        role="button"
        class="dropdown-item f-s-14 mt-1 mb-1"
        (click)="saveLayout('add')"
      >
        <i class="fal fa-save" style="color: #9e9e9e" aria-hidden="true"></i>
        {{ "save_design" | translate }}
      </a>
      <accordion style="padding-top: 0">
        <accordion-group
          [isOpen]="isTemplatesOpen"
          (isOpenChange)="isTemplatesOpen = $event"
          [panelClass]="'template-accordion'"
        >
          <div accordion-heading class="clearfix timeline-accordion-header">
            <i class="fal fa-list-alt ml-1"></i>
            {{ "saved_designs" | translate }}
          </div>
          <div style="overflow-y: auto; max-height: 350px">
            <ul class="timeline">
              <li
                *ngFor="let template of templates; let i = index"
                [class.active]="template.id === currentTemplate?.id"
              >
                <a
                  role="button"
                  class="dropdown-item position-relative"
                  (click)="selectLayout(template, i)"
                  >{{ template.description }}</a
                >
                <span class="process-icons">
                  <i
                    class="fal fa-edit template-process text-success"
                    (click)="saveLayout('edit', template, i)"
                  ></i>
                  <i
                    class="fal fa-trash-alt template-process text-danger"
                    (click)="deleteLayout(template, i)"
                  ></i>
                </span>
              </li>
            </ul>
          </div>
        </accordion-group>
      </accordion>
    </tab>
    <tab [heading]="'column_add_or_remove' | translate" id="tab1">
      <kl-column-picker
        *ngIf="isSidebarShow"
        [flexGrid]="flexGrid"
      ></kl-column-picker>
    </tab>
  </tabset>
</p-sidebar>
<kl-preference-form
  (onSetPreference)="commitSave($event)"
  [saveForm]="saveForm"
></kl-preference-form>
